import React, { useEffect } from 'react'
import Layout from "../Layout"
import ListKelas from '../../components/kelas/ListKelas'
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getMe } from "../../features/authSlice"

const Kelas = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isError } = useSelector((state) => state.auth)

    useEffect(() => {
        dispatch(getMe())
    }, [dispatch])

    if (isError) {
        return navigate("/login")
    }

    return (
        <Layout>
            <title>Kelas</title>
            <ListKelas />
        </Layout>
    )
}

export default Kelas